import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Form from '../Form';

class ManualSettlementForm extends Form {
    static fieldsValidation = {
        payout: [ 'required', 'decimal' ]
    };

    static defaultProps = {
        ...Form.defaultProps,
        markValid: false
    };

    onSubmit(e) {
        e.preventDefault();

        Form.prototype.onSubmit.call(this, e);
    }

    renderForm() {
        const { errors } = this.props;

        return (
            <div className="manual-settlement-form">
                <h4 data-test='manual-settlement-form-header'>Manual settlement</h4>

                {
                    this.getField(
                        <input
                            type="text"
                            name="payout"
                            label="Payout"
                            { ...this.getFieldParameters('payout') }
                        />
                    )
                }

                { this.getBasicError(errors.get && errors.get('program')) }

                <div className="buttons">
                    <button type="submit" className="btn">Settle manually</button>
                </div>
            </div>
        );
    }
}

export default ManualSettlementForm;
